import React from "react";
import ReactMarkdown from "react-markdown";
import codeBlock from './CodeBlock';
import AppMarkdown from './help.md';
import "github-markdown-css/github-markdown.css";

class Read extends React.Component{
    state = {
        markdown: '',
    };

    componentWillMount() {
        fetch(AppMarkdown)
            .then(res => res.text())
            .then(text => this.setState({ markdown: text }));
    }

    render() {
        const { markdown } = this.state;
        return(
                <ReactMarkdown
                    source={markdown}
                    className="markdown-body"
                    escapeHtml={false}
                    renderers={{
                        code: codeBlock,
                    }}
                />
        )
    }
}

export default Read;
